var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.139,
    height: 26.664,
    viewBox: "0 0 37.139 26.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6793",
    "data-name": "Group 6793",
    transform: "translate(-157.082 -459.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54241",
    "data-name": "Path 54241",
    d: "M193.561,463.694a.66.66,0,0,0-.661.66v6.8l-.01-.009V475.6l.01-.009v1.377l0,0V482.4a.66.66,0,1,0,1.321,0V478.55h0v-14.2A.659.659,0,0,0,193.561,463.694Z",
    fill: "#e8585d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6792",
    "data-name": "Group 6792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54242",
    "data-name": "Path 54242",
    d: "M188.919,463.909l-5.423,3.58a4.544,4.544,0,0,0-.991-2.154l-18.35,18.351h14.853a4.551,4.551,0,0,0,4.548-4.372l5.364,3.541c1.3.86,2.932-.216,2.932-1.938v-15.07C191.852,464.123,190.219,463.047,188.919,463.909Z",
    fill: "#e8585d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54243",
    "data-name": "Path 54243",
    d: "M180.891,464.122h0l2.566-2.565a1,1,0,0,0-1.414-1.414l-3.555,3.554H162.838a4.554,4.554,0,0,0-4.553,4.552v10.885a4.491,4.491,0,0,0,1.454,3.309l-2.364,2.364a1,1,0,1,0,1.414,1.414l2.746-2.746h0Z",
    fill: "#e8585d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDisable);
export default __webpack_public_path__ + "static/media/VideoDisable.c32414144331c49b601488d9c66e3a95.svg";
export { ForwardRef as ReactComponent };